module.exports = "../../static/img/marketplace.5ca47ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/marketplace.png
// module id = 1283
// module chunks = 4